import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class UploadFilesApis {
  static getS3PresignedURL = async (payload) => {
    const url = `${process.env.DOCUMENT_HELPER_API_URL}api/v1/aws/s3/presigned-url/put-object`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });

    return res;
  };
  static updateACL = async (payload) => {
    const url = `${process.env.DOCUMENT_HELPER_API_URL}api/v1/aws/s3/presigned-url/update-acl`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });

    return res;
  };
}
